import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';

export default class PayConfirmModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.price = vnode.attrs.price;
    this.payType = vnode.attrs.payType;
    this.payItem = this.payType[0];
    this.goodsId = vnode.attrs.goodsId;
    this.pcChargeDiscount = vnode.attrs.pcChargeDiscount || 100;
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small pay-confirm-modal in';
  }

  title() {
    return;
  }
  oncreate() {
    const imgUrls = [
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/paypal-while.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/payermax-while.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/xsolla-while.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/airwallex-while.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/antom_buttom.png`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/enjoyPay_button.png`,
    ];
    imgUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
    let item = document.getElementsByClassName('pay-btn')[0];
    if (this.payItem == 12) {
      item.style.background = `url("${imgUrls[0]}")`;
    } else if (this.payItem == 16) {
      item.style.background = `url("${imgUrls[1]}")`;
    } else if (this.payItem == 15) {
      item.style.background = `url("${imgUrls[2]}")`;
    } else if (this.payItem == 17) {
      item.style.background = `url("${imgUrls[3]}")`;
    } else if (this.payItem == 19) {
      item.style.background = `url("${imgUrls[4]}")`;
    } else if (this.payItem == 24) {
      item.style.background = `url("${imgUrls[5]}")`;
    }
  }

  content() {
    // 12 paypal 15xsolla 16payermax
    return (
      <div className="pay-confirm-modal-box">
        <div className="title">{app.translator.trans('dl-pay.forum.order.confirm_payment_order')}</div>
        <div className="pay-confirm-modal-content">
          <div className="tip">{app.translator.trans('dl-pay.forum.user.wallet_recharge')}</div>
          <div className="price">${this.pcChargeDiscount < 100 ? (this.price * this.pcChargeDiscount / 100).toFixed(2) : this.price}</div>
          <div className="payment-method-box">
            <div
              className={`pay-method-item pay-style-paypal${this.payItem == 12 ? ' pay-item-check' : ''}`}
              style={`display: ${this.payType?.includes('12') ? 'display' : 'none'}`}
              onclick={() => {
                this.onClickPayItem(12);
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/paypal.png`} alt="【图片】"></img>Paypal
            </div>
            <div
              className={`pay-method-item pay-style-payermax${this.payItem == 16 ? ' pay-item-check' : ''}`}
              style={`display: ${this.payType?.includes('16') ? 'display' : 'none'}`}
              onclick={() => {
                this.onClickPayItem(16);
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/payermax.png`} alt="【图片】"></img>payermax
            </div>
            <div
              className={`pay-method-item pay-style-xsolla${this.payItem == 15 ? ' pay-item-check' : ''}`}
              style={`display: ${this.payType?.includes('15') ? 'display' : 'none'}`}
              onclick={() => {
                this.onClickPayItem(15);
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/xsolla.png`} alt="【图片】"></img>xsolla
            </div>
            <div
              className={`pay-method-item pay-style-airwallex${this.payItem == 17 ? ' pay-item-check' : ''}`}
              style={`display: ${this.payType?.includes('17') ? 'display' : 'none'}`}
              onclick={() => {
                this.onClickPayItem(17);
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/airwallex.png`} alt="【图片】"></img>airwallex
            </div>
            <div
              className={`pay-method-item pay-style-airwallex${this.payItem == 19 ? ' pay-item-check' : ''}`}
              style={`display: ${this.payType?.includes('19') ? 'display' : 'none'}`}
              onclick={() => {
                this.onClickPayItem(19);
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/atom.jpg`} alt="【图片】"></img>antom
            </div>
            <div
              className={`pay-method-item pay-style-airwallex${this.payItem == 24 ? ' pay-item-check' : ''}`}
              style={`display: ${this.payType?.includes('24') ? 'display' : 'none'}`}
              onclick={() => {
                this.onClickPayItem(24);
              }}
            >
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/enjoypay.png`} alt="【图片】"></img>EnjoyPay
            </div>
          </div>
          <div
            className="pay-btn"
            onclick={() => {
              this.onclickPayButtom();
            }}
          ></div>
        </div>
      </div>
    );
  }
  onClickPayItem(e) {
    this.payItem = e;
    const imgurl12 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/paypal-while.png`;
    const imgurl16 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/payermax-while.png`;
    const imgurl15 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/xsolla-while.png`;
    const imgurl17 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/airwallex-while.png`;
    const imgurl19 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/antom_buttom.png`;
    const imgurl24 = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/enjoyPay_button.png`;
    let item = document.getElementsByClassName('pay-btn')[0];
    if (this.payItem == 12) {
      item.style.background = `url("${imgurl12}")`;
    } else if (this.payItem == 16) {
      item.style.background = `url("${imgurl16}")`;
    } else if (this.payItem == 15) {
      item.style.background = `url("${imgurl15}")`;
    } else if (this.payItem == 17) {
      item.style.background = `url("${imgurl17}")`;
    } else if (this.payItem == 19) {
      item.style.background = `url("${imgurl19}")`;
    } else if (this.payItem == 24) {
      item.style.background = `url("${imgurl24}")`;
    }
  }
  onclickPayButtom() {
    // 发起支付接口
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/sdkPay',
        params: {
          money: this.price,
          goodsId: this.goodsId,
          payType: this.payItem,
          orderType: 2, // 充值平台币
        },
      })
      .then((res) => {
        this.hide();
        if (res.payUrl) {
          window.location.href = res.payUrl;
          // window.open(res.payUrl);
          // TODO 支付成功弹窗
        } else {
          console.log('获取支付链接失败' + res);
          // TODO 支付失败弹窗
        }
      });
  }
}
